import React from 'react';
import './bookingTerms.css';
import { NavLink } from 'react-router-dom';
import bannerLogo from '../../assets/images/OGR_Login_logo.png';

const BookingTerms = () => {
  return (
    <>
        {/* Navigation */}
        <nav className="navbar navbar-default" role="navigation">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-10 padding-lr0">
                            <div className="navbar-brand">
                                <NavLink  to="/">
                                    <img id="asideBrandLogo" alt="Logo" src={bannerLogo} height="35"/>
                                </NavLink>
                                <div>Oxford Golf Resort<small> Tee Time Booking</small></div>
                            </div>
                        </div>
                    </div>
                </div>
        </nav>
        <div className="container">
        <div className="row padding-t15">
            <div className="col-xs-12 padding-lr15 text-center">
            <h3 className="text-header">Booking Terms</h3>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15 text-center">
            <h5 className="dark-color">1.VISITORS/ MEMBER GUESTS ONLINE BOOKINGS - TERMS AND CONDITIONS:
            </h5>
            <h6 className="text-policy">These are the terms and conditions for Visitors booking online tee times using our Internet booking facility.
            </h6>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15">
            <h4 className="dark-color">Payment</h4>
            <p className="text-policy">To book a tee time online you will have to enter your credit or debit card details using our secure online payment process. You should report to the Starter before beginning your round.</p>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15">
            <ul className="ul text-policy">
                <li className="li">-- Bookings can be made one month in advance for weekdays and 15 days in advance for weekends.</li>
                <li className="li">-- Cart & Caddy are mandatory on this Golf Course.</li>
                <li className="li">-- A Caddy is mandatory on this course even if you hire a cart.</li>
                <li className="li">-- ONLY 18-HOLE ROUNDS are allowed on this golf course. If you would like to play 9-hole round, then you will have to pay the entire 18-hole round green fee.</li>
                <li className="li">-- Driving Range FEE is for the "Bucket of first 50 balls"</li>
                <li className="li">-- We accept only VISA and MASTERCARD debit/credit cards.</li>
            </ul>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15">
            <p className="text-policy">For bookings made under the IGU Member head: The golfer should carry & furnish their ORIGINAL IGU cards at the golf course on the day of play. Failure to do so would NOT qualify you for the IGU rates. In such case normal walk in visitors green fees will apply & the difference in rates will need to be paid.</p>
            <p className="text-policy">For bookings made under the Affiliated Club member head: The golfer should carry & furnish the INTRODUCTORY LETTER/ membership card/ handicap card from the affiliated club that confirms that it is their home/ golf club. Failure to do so would NOT qualify you for the Affiliate club rates. In such case normal walk in visitors green fees will apply & the difference in rates will need to be paid.</p>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15">
            <h4 className="dark-color">Cancellation Policy
            </h4>
            <p className="text-policy">If cancellation is made up-to 24 hrs before the tee time - a cancellation fee of 200 INR will be applicable per player. If cancellation is made less than 24 hrs before the tee time - the booking amount will be non-refundable. Refunds will be made within 2-3 weeks of cancellation depending on the bank account</p>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15">
            <h4 className="dark-color">Failure To Cancel Your Booking
            </h4>
            <p className="text-policy">If you fail to cancel your booking, there will be no refund and there will be a charge of 100% of the green fee made to your credit/debit card.</p>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15">
            <h4 className="dark-color">Course Closed        
            </h4>
            <p className="text-policy">If you are unable to play your round of golf due to the course being closed (e.g. rain / tournament/ course maintenance) full refund will be made to your credit/debit card.</p>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15">
            <h4 className="dark-color">Visitor Booking is Transferable  
            </h4>
            <p className="text-policy">The Booking is NOT Transferable. Therefore, should you be unable to make your tee time, you cannot offer the tee time to someone else such as a family member or friend.</p>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15">
            <h4 className="dark-color">Dress Code  
            </h4>
            <p className="text-policy">Normal Golf dress code applies. The following are therefore not permitted on the course : Denims, football/rugby tops,tracksuits.</p>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15">
            <h4 className="dark-color">Spikes
            </h4>
            <p className="text-policy">Soft Spikes only may be worn on the course.</p>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15 text-center">
            <h5 className="dark-color">2.MEMBERS BOOKING ONLINE TERMS AND CONDITIONS:</h5>
            <h6 className="text-policy">These are the terms and conditions for Members booking tee times using our online Internet Booking facility.
            </h6>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15">
            <h4 className="dark-color">1.Payment</h4>
            <p className="text-policy">Book a Tee Time as normal, enter your details in tee time flow. Green fees for Member guests will have to be paid.</p>
            </div>
        </div>

        <div className="row">
            <div className="col-xs-12 padding-lr15">
            <ul className="ul text-policy">
                <li className="li">-- Only 2 bookings (teetimes) per day are allowed for Members.</li>
                <li className="li">-- Bookings can be made one month in advance for weekdays and 15 days in advance for weekends.</li>
                <li className="li">-- Cart & Caddy are mandatory on this Golf Course.</li>
                <li className="li">-- A Caddy is mandatory on this course even if you hire a cart.</li>
                <li className="li">-- ONLY 18-HOLE ROUNDS are allowed on this golf course. If you would like to play 9-hole round, then you will have to pay the entire 18-hole round green fee.</li>
                <li className="li">-- Driving Range FEE is for the "Bucket of first 50 balls"</li>
                <li className="li">-- We accept only VISA and MASTERCARD debit/credit cards.</li>
            </ul>
            </div>
        </div>
        </div>
    </>
  );
};

export default BookingTerms;